export default __webpack_public_path__ + "static/media/interview01_1.c800b6e6.jpg";